const initialState={
    data:[],
   dataview:[],
  };
  const DaddFeedback=(state=initialState,action:any)=>{
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
          return { ...state, data: action.payload };
          case 'FETCH_ADD_DATA_SUCCESS':
            return { ...state, dataview: action.payload };  
        default:
          return state;
  }
  };
  export default DaddFeedback;